module.exports = __webpack_public_path__ + "img/6b2433d.png";